
<section id="rcs">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Risk Capacity Survey</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row" [hidden]="survey!=null">
      <div class="col-sm-12">
        <h2>Select A Risk Capacity Survey</h2>
      </div>
      <!-- <div class="col-sm-6">
      <button type="button" class="btn surveyButtons mb-5" [routerLink]="['/survey/47']" (click)="clearPreviousResults('47')">
        IFC Institutional - 10 Question
      </button>
    </div> -->
    <!-- <div class="clearfix mb-5"></div> -->
    <div class="col-sm-12">
      <button type="button" class="btn surveyButtons mb-5" [routerLink]="['/survey/50']" (click)="clearPreviousResults('50')">
        IFC Individual - 5 Questions
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      @if (survey!=null) {
        <div>
          <div class="mb-2">
            <app-progress-bar [max]="survey.questions.length" [value]="questionIndex + 1"></app-progress-bar>
          </div>
          <div>
            <app-survey-question [question]="survey.questions[questionIndex]" [surveyResultId]="survey.resultId" (answered)="answered($event)"></app-survey-question>
          </div>
        </div>
      }

    </div>
  </div>
</div>
</section>